export interface BaseAddressyItem {
  Id: string;
  Text: string;
  Highlight: string;
  Description: string;
  Type: AddressyItemType;
}

export enum AddressyItemType {
  Address = 'Address',
  Container = 'Container'
}
